import { eff } from "@/core/utils/effect-ts-abbr";
import { ColorFilterItemDto } from "@/shared/api-contract/api-contract";
import tinycolor from "tinycolor2";
import { watchEffect } from "vue";
import { Emit, Model, Prop, Vue } from "vue-property-decorator";

type ColorOption = {
    hex: string;
    label: string;
    isLight: boolean;
    value: number;
};

export class ColorListComponent extends Vue {
    @Model("modelValue", { required: true })
    model!: readonly number[];

    @Prop({ type: Array, required: true })
    options!: ColorFilterItemDto[];

    /**
     * Block dropdown when no options provided.
     */
    @Prop({ default: true, type: Boolean })
    blockEmpty!: boolean;

    /**
     * Block dropdown when single item provided in the options.
     */
    @Prop({ default: false, type: Boolean })
    blockSingle!: boolean;

    get blocked() {
        return (
            (!this.options.length && this.blockEmpty) ||
            (this.options.length <= 1 && this.blockSingle)
        );
    }

    isOptionSelected(option: ColorOption) {
        return this.model.includes(option.value);
    }

    get preparedOptions(): readonly ColorOption[] {
        return eff.fn.pipe(
            this.options,
            eff.array.map((option) => ({
                hex: option.hex,
                label: option.name,
                value: option.id,
                counter: option.counter,
                isLight: tinycolor(option.hex).isLight(),
            })),
        );
    }

    @Emit("blocked")
    emitBlocked() {
        return this.blocked;
    }

    mounted() {
        watchEffect(() => {
            this.emitBlocked();
        });
    }

    toggleOption(option: ColorOption, value = !this.isOptionSelected(option)): void {
        if (value && !this.isOptionSelected(option)) {
            this.model = [...this.model, option.value];
        }

        if (!value && this.isOptionSelected(option)) {
            this.model = eff.fn.pipe(
                this.model,
                eff.array.filter((it) => it !== option.value),
            );
        }
    }
}
